import {Stack, Typography} from '@mui/material';
import React from 'react';
import {StyledButton} from './styles';
import {UnitCardAddressProps} from './types';
import {DistanceReference} from './components/DistanceReference';

export function UnitCardAddress({
	address,
	onOpenMap,
	seeMapLabel,
	seeMapDataTagId,
	showDistanceReference,
	distanceFilterDescription,
	distanceReference,
}: UnitCardAddressProps) {
	return (
		<Stack mb="auto" gap={1} direction="column">
			<Typography
				variant="body2"
				color="text.secondary"
				textOverflow="ellipsis"
				overflow="hidden">
				{address} {' - '}
				<StyledButton variant="text" onClick={onOpenMap} data-tag-id={seeMapDataTagId}>
					{seeMapLabel}
				</StyledButton>
			</Typography>
			{showDistanceReference ? (
				<DistanceReference
					distance={distanceReference!}
					distanceDescription={distanceFilterDescription}
				/>
			) : null}
		</Stack>
	);
}
